import {useQuery} from 'react-query'
 import {AreaEditModalForm} from './AreaEditModalForm'
//  import {isNotEmpty, QUERIES} from '../../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
 import {getAreaById} from '../core/_requests'
import { QUERIES, isNotEmpty } from '../../../../../_metronic/helpers'

const AreaEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)
  const dataresponse = {name:"demo"}
  const {
    isLoading,
    data: area,
    error,
  } = useQuery(
    `${QUERIES.AREAS_LIST}-area-${itemIdForUpdate}`,
    () => {
      return getAreaById(itemIdForUpdate)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
       // setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <AreaEditModalForm isAreaLoading={false} area={{id: undefined}} />
  }

  if (itemIdForUpdate) {
    return <AreaEditModalForm isAreaLoading={false} area={dataresponse} />
  }

  return null
}

export {AreaEditModalFormWrapper}
